import { useEffect, useState } from "react";
import { toast } from "sonner";
import { FloppyDisk, Tag } from "@phosphor-icons/react";
import { AppHeader } from "@/components/AppHeader";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";

export default function InstallLabelSettings() {
  const [fields, setFields] = useState({});
  const [options, setOptions] = useState([]);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/settings/install-label").then(({ data }) => {
      setFields(data.fields || {});
      setOptions(data.options || []);
    });
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      const { data } = await api.put("/settings/install-label", { fields });
      setFields(data.fields || {});
      toast.success("Label fields saved");
    } catch {
      toast.error("Could not save");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="grain min-h-screen">
      <AppHeader title="Install Label" />
      <main className="relative z-10 mx-auto max-w-2xl pb-20 pt-6">
        <div className="text-xs uppercase tracking-widest text-zinc-600">Settings</div>
        <h1 className="text-2xl font-bold tracking-tight sm:text-3xl" data-testid="install-label-title">
          Install Label
        </h1>
        <p className="mt-1 text-sm text-zinc-500">
          Choose what prints on the 4×6 installation label (Job → Print install label).
        </p>

        <div className="mt-6 rounded-lg border border-zinc-800 bg-zinc-900 p-4">
          <div className="flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-zinc-400">
            <Tag size={15} weight="bold" /> Fields on the label
          </div>
          <div className="mt-3 grid gap-2 sm:grid-cols-2" data-testid="install-label-fields">
            {options.map((o) => (
              <label
                key={o.key}
                className="flex cursor-pointer items-center gap-3 rounded-md border border-zinc-800 bg-zinc-950 px-3 py-2 transition-colors duration-150 hover:bg-zinc-800"
              >
                <input
                  type="checkbox"
                  data-testid={`label-field-${o.key}`}
                  checked={!!fields[o.key]}
                  onChange={(e) => setFields((f) => ({ ...f, [o.key]: e.target.checked }))}
                  className="h-4 w-4 accent-indigo-500"
                />
                <span className="text-sm text-zinc-200">{o.label}</span>
              </label>
            ))}
          </div>
        </div>

        <div className="mt-6 flex justify-end">
          <Button onClick={save} disabled={saving} data-testid="install-label-save-btn">
            <FloppyDisk size={15} weight="bold" className="mr-1" /> {saving ? "Saving…" : "Save"}
          </Button>
        </div>
      </main>
    </div>
  );
}
